import { Pipe, PipeTransform } from '@angular/core';
/*
 * L2-R6: moved from
 * `src/app/shared/components/tree-data-table/tree-data-row/contextualized.pipe.ts` (4 reports
 * references). Zero dependencies beyond @angular/core. The old host path is a re-export shim.
 */
export interface Contextualized {
  contextProvider?: (x: any) => any;
}
/**
 * It transform provided `data` using a `contextProvided` function (from params)
 * to return a contextualized object; else return the `data` as is
 */
@Pipe({ name: 'contextualized' })
export class ContextualizedPipe implements PipeTransform {
  public static doTransform(data: any, args: { contextProvider?: (x: any) => any }) {
    const { contextProvider } = args;
    return contextProvider && typeof contextProvider === 'function' ? contextProvider(data) : data;
  }
  transform(data: any, args) {
    return ContextualizedPipe.doTransform(data, args);
  }
}
